import * as React from 'react'
import style from './style.css'

interface IIconProps {
  viewBox?: string
  width?: string
  height?: string
  onClick?: () => void
  isActive?: boolean
  className?: string
  color?: string
  strokeWidth?: string
}

const Close = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color ? props.color : '#fff'}
      fillRule="evenodd"
      d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z"
    />
  </svg>
)

export const Copy = (props?: IIconProps) => (
  <svg
    className={props.className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.10254 15.6919H4.86523V17.0186C4.86523 18.8184 5.78369 19.7368 7.60205 19.7368H16.9165C18.7256 19.7368 19.6533 18.8091 19.6533 17.0186V7.65771C19.6533 5.86719 18.7256 4.94873 16.9165 4.94873H15.1538V3.61279C15.1538 1.83154 14.2261 0.903809 12.417 0.903809H3.10254C1.28418 0.903809 0.365723 1.81299 0.365723 3.61279V12.9829C0.365723 14.7734 1.28418 15.6919 3.10254 15.6919ZM3.12109 14.5415C2.08203 14.5415 1.51611 13.9941 1.51611 12.918V3.67773C1.51611 2.60156 2.08203 2.0542 3.12109 2.0542H12.3984C13.4189 2.0542 14.0034 2.60156 14.0034 3.67773V4.94873H7.60205C5.78369 4.94873 4.86523 5.85791 4.86523 7.65771V14.5415H3.12109ZM7.62061 18.5864C6.58154 18.5864 6.01562 18.0298 6.01562 16.9629V7.71338C6.01562 6.64648 6.58154 6.08984 7.62061 6.08984H16.8979C17.9185 6.08984 18.5029 6.64648 18.5029 7.71338V16.9629C18.5029 18.0298 17.9185 18.5864 16.8979 18.5864H7.62061Z"
      fill="white"
    />
  </svg>
)

const CloseVideo = (props?: IIconProps) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    className={props.className}
    onClick={props.onClick}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="25" cy="25" r="25" fill="#1F1F1F" />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="3"
        d="M14 14l21.213 21.213M14 35.213L35.213 14"
      />
    </g>
  </svg>
)

const PodWhite = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.378 19.656c-1.037-1.627-2.923-4.817-3.732-6.433a2.424 2.424 0 0 1-.008-2.174c.842-1.733 2.616-4.783 3.688-6.458a2.373 2.373 0 0 1 1.885-1.1c1.83-.103 5.58-.134 7.408-.024.779.046 1.435.454 1.893 1.085 1.09 1.502 2.906 4.657 3.732 6.433.328.704.35 1.477.008 2.174-.833 1.693-2.66 4.931-3.688 6.458-.435.648-1.107 1.052-1.885 1.1-1.873.113-5.569.112-7.408.025a2.348 2.348 0 0 1-1.893-1.086z"
      />
      <path fill="#fff" d="M10.817 9.731a.951.951 0 1 1-1.902 0 .951.951 0 0 1 1.902 0" />
    </g>
  </svg>
)

const CartBlack = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill="#3c396f"
        d="M16.75 21.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm-6 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zM2.5 2.5h3.51c.27 0 .561.214.647.47L8.5 8.5 7 7.5 5.672 3.959a.756.756 0 0 0-.667-.459H2.5v-1z"
      />
      <path
        stroke="#3c396f"
        d="M7.58 8l1.118 7.45c.127.844.947 1.55 1.794 1.55h7.016c.857 0 1.725-.714 1.892-1.55L20.89 8H7.58z"
      />
    </g>
  </svg>
)

const SignOut = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <g className={style.strokeDefault} strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 8l-4 4 4 4M17 12H4.248M13 4h8v16h-8" />
      </g>
    </g>
  </svg>
)

const PartialLogo = (props?: IIconProps) => {
  const width = props.width ? props.width : '18px'
  const height = props.height ? props.height : '16px'

  return (
    <svg width={width} height={height} viewBox="0 0 18 16">
      <g className={style.fillDefault} fillRule="evenodd">
        <path d="M13.448 9.076l-.001-.001a.851.851 0 0 1-.002.849v-.001l-2.153 3.726a2.059 2.059 0 0 1-1.783 1.027l-4.849-.001c-.176 0-.34.12-.368.294a.354.354 0 0 0 .35.413l4.867.002c.989 0 1.902-.527 2.396-1.381l2.154-3.726.001-.001a1.56 1.56 0 0 0 .002-1.553v-.001l-1.792-3.1a.255.255 0 0 0-.221-.128h-.562a.064.064 0 0 0-.055.095l2.016 3.487z" />
        <path d="M9.92 12.41v-.002a.85.85 0 0 1-.737.424h.001-4.308a2.059 2.059 0 0 1-1.782-1.028L.67 7.61C.58 7.45.38 7.37.21 7.447a.353.353 0 0 0-.162.5l2.432 4.21a2.767 2.767 0 0 0 2.396 1.382h4.309a1.567 1.567 0 0 0 1.348-.775l1.794-3.1a.255.255 0 0 0 0-.255l-.281-.486a.064.064 0 0 0-.11 0L9.92 12.41z" />
        <path d="M5.265 11.026h.001a.853.853 0 0 1-.735-.426L2.377 6.875a2.053 2.053 0 0 1 0-2.056L4.803.626c.088-.152.066-.354-.07-.465a.355.355 0 0 0-.534.095l-2.435 4.21a2.76 2.76 0 0 0 0 2.762l2.153 3.726v.001a1.563 1.563 0 0 0 1.347.778l3.586.001a.255.255 0 0 0 .22-.127l.281-.486a.064.064 0 0 0-.055-.095H5.265z" />
        <path d="M4.138 6.308v.001a.85.85 0 0 1 .002-.85v.002l2.154-3.726A2.059 2.059 0 0 1 8.076.707l4.85.002c.176 0 .34-.12.367-.294a.354.354 0 0 0-.349-.413L8.076 0C7.087 0 6.174.526 5.68 1.38L3.526 5.108a1.56 1.56 0 0 0-.003 1.554h.001l1.791 3.101c.046.08.13.128.221.128h.562c.049 0 .08-.053.055-.096L4.138 6.308z" />
        <path d="M7.665 2.974v.001a.853.853 0 0 1 .737-.423H8.4h4.308c.735 0 1.415.392 1.782 1.028l2.423 4.193c.093.16.292.24.461.164a.353.353 0 0 0 .163-.5l-2.433-4.21a2.768 2.768 0 0 0-2.396-1.383H8.4a1.567 1.567 0 0 0-1.348.775v.001l-1.793 3.1a.254.254 0 0 0 0 .255l.28.485a.064.064 0 0 0 .11 0l2.016-3.486z" />
        <path d="M12.32 4.358h-.001a.855.855 0 0 1 .736.426l2.153 3.725a2.053 2.053 0 0 1 0 2.055l-2.426 4.193c-.088.153-.066.354.071.466.174.142.425.09.533-.096l2.436-4.209a2.76 2.76 0 0 0 0-2.762l-2.154-3.727a1.563 1.563 0 0 0-1.346-.778h-.002l-3.584-.002a.255.255 0 0 0-.221.128l-.281.486a.064.064 0 0 0 .055.095h4.031z" />
      </g>
    </svg>
  )
}

/* Dashboard navigation icons */

const House = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      className={props.isActive ? style.fillActive : style.fillDefault}
      fillRule="evenodd"
      d="M12.045 2.488L2.295 14l.647.763 2.677-3.02v6.96c0 1.478.955 2.677 2.427 2.677h7.998c1.473 0 2.478-1.199 2.478-2.677v-6.96l2.626 3.02.699-.702-9.802-11.574zm5.332 16.49c0 .739-.597 1.338-1.333 1.338H8.046c-.736 0-1.355-.6-1.355-1.339V10.45l5.354-6.489 5.355 6.468-.023 8.548z"
    />
  </svg>
)

const Network = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" className={props.className}>
    <g className={props.isActive ? style.fillActive : style.fillDefault} fillRule="evenodd">
      <path d="M11.5 16h1v-3h-1v3zm3.168-6.521l2.264-1.968-.656-.755-2.264 1.968.656.755zm-5.392.105l.656-.754L7.668 6.86l-.656.755 2.264 1.968zM12 19.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zM18.488 6.867a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zM5.447 6.867a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zM12.006 12.086a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z" />
    </g>
  </svg>
)

const Account = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      className={props.isActive ? style.fillActive : style.fillDefault}
      fillRule="evenodd"
      d="M17.173 17.696c-.227-.086-.598-.17-1.1-.25-.57-.088-.892-.148-1.014-.189-.678-.199-1.068-.374-1.259-.63-.212-.282-.228-.923-.15-2.376l.006-.104.484-.968c.085-.237.193-.724.317-1.437l.072-.414h.318a.835.835 0 0 0 .066-.213c.172-.747.287-1.282.287-1.287 0-.01-.1-.043-.301-.1l.055-.46.246-2.059c.029-.76-.235-1.42-.808-2.007-.567-.581-1.353-.874-2.392-.874s-1.825.293-2.392.874c-.573.587-.837 1.246-.808 2.008.032.927.11 1.59.228 1.97l.199.648H8.8c0 .108.033.278.102.5.09.288.154.543.191.768.014.08.03.141.045.182h.314l.428 1.956c.09.229.222.491.399.786l.074.125-.057 2.355-.096.128c-.191.255-.58.43-1.242.624-.139.046-.46.106-1.03.195-.503.078-.874.163-1.101.249-1.259.474-1.98 1.022-2.228 1.632H19.4c-.248-.61-.97-1.158-2.228-1.632zm-1.815-1.393c.061.02.373.078.87.156.563.088.993.186 1.298.3 1.94.733 2.974 1.747 2.974 3.069v.5h-17v-.5c0-1.322 1.034-2.336 2.974-3.068.305-.115.735-.213 1.299-.301.496-.078.808-.135.886-.161.304-.09.529-.175.647-.225l.04-1.665a5.817 5.817 0 0 1-.414-.855l-.02-.068-.288-1.314c-.277-.16-.446-.485-.517-.911a4.86 4.86 0 0 0-.16-.633 2.745 2.745 0 0 1-.147-.8c0-.191.026-.36.086-.51a.903.903 0 0 1 .1-.185c-.098-.467-.158-1.093-.186-1.886-.038-1.039.331-1.963 1.092-2.742.767-.786 1.813-1.176 3.108-1.176 1.295 0 2.341.39 3.108 1.176.76.78 1.13 1.703 1.088 2.783l-.214 1.8c.15.18.218.44.218.74 0 .13-.085.527-.31 1.499-.045.226-.117.42-.224.579a1.149 1.149 0 0 1-.275.299c-.118.638-.223 1.083-.323 1.35l-.02.047-.404.807c-.029.555-.04.988-.032 1.295.004.148.012.264.023.343.088.042.342.145.723.257z"
    />
  </svg>
)

const User = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="-2 -4 22 22">
    <path
      className={props.isActive ? style.fillActive : style.fillDefault}
      fillRule="evenodd"
      d="M10.525 11.755h.077c.28 0 .561.001.842-.002.09 0 .18-.007.268-.026.243-.053.427-.182.481-.44.024-.115.024-.236.025-.355.007-.775.013-1.55.014-2.324 0-.285-.006-.57-.022-.853a.558.558 0 0 0-.326-.49.89.89 0 0 0-.411-.081H6.488c-.034 0-.07.001-.104.004a.718.718 0 0 0-.367.122c-.208.145-.283.356-.283.6l-.003 2.738c0 .161-.002.323.009.484.017.253.137.446.375.545.097.04.208.069.313.072.321.01.643.005.964.006.08 0 .081 0 .081.079 0 .997 0 1.994.002 2.99 0 .092.005.184.019.275.034.227.149.399.363.496a.902.902 0 0 0 .364.078c.358.004.716.009 1.074.005.21-.001.423-.001.63-.031a.602.602 0 0 0 .536-.493c.023-.102.03-.21.03-.316.003-.85.001-1.7.005-2.55 0-.175.018-.35.029-.533zm5.867-.095v.077c0 .6.002 1.2 0 1.8 0 .191.01.384-.04.57-.149.558-.518.886-1.074 1.007-.131.029-.27.034-.405.034-.506.001-1.014.011-1.52-.011-.598-.026-1.143-.505-1.237-1.067-.017-.102-.012-.209-.014-.313 0-.015.017-.04.03-.043.135-.022.27-.053.407-.057.176-.006.307.086.39.24a.55.55 0 0 1 .047.1c.065.215.224.314.433.333.187.016.374.016.561.017a49.7 49.7 0 0 0 .97-.007.856.856 0 0 0 .21-.033.522.522 0 0 0 .398-.508c.006-.545.007-1.09.009-1.636l-.002-1.234c0-.085 0-.085.088-.085.28 0 .558.001.837-.004.082-.002.165-.018.244-.04.24-.066.37-.232.405-.475.008-.052.011-.106.011-.159V7.49c0-.07-.007-.143-.022-.213a.499.499 0 0 0-.378-.408 1.166 1.166 0 0 0-.299-.04c-1.246-.002-2.493-.001-3.74 0-.015 0-.031.002-.054.004.01.015.014.026.022.035a1.5 1.5 0 0 1 .385 1.028c.004 1.057.005 2.115 0 3.172-.002.392-.124.745-.403 1.03a1.466 1.466 0 0 1-.84.424c-.145.023-.293.03-.439.041-.043.004-.06.016-.06.063-.003.42-.012.84-.01 1.26 0 .276.015.551.024.826.01.314-.029.62-.163.907-.21.449-.572.705-1.046.815-.257.06-.516.06-.778.048-.24-.012-.48-.01-.721-.009-.26.001-.52.014-.78-.04a1.449 1.449 0 0 1-1.165-1.249 1.762 1.762 0 0 1-.014-.225l.001-2.22c0-.179-.005-.186-.188-.191a1.89 1.89 0 0 1-.744-.156c-.438-.201-.685-.55-.776-1.016a1.978 1.978 0 0 1-.036-.371c-.002-1.04-.003-2.079 0-3.118a1.492 1.492 0 0 1 .397-1.035l.004-.018c-.018-.001-.035-.004-.051-.004-1.24 0-2.479-.002-3.718 0-.095 0-.19.016-.283.037-.226.054-.355.204-.392.431a1.72 1.72 0 0 0-.022.268c-.002.847-.002 1.693 0 2.54 0 .093.009.187.026.278.047.25.207.39.452.434.097.017.197.025.295.027.237.003.474 0 .71 0h.08V13.637c0 .09.008.184.026.273.05.235.206.365.437.409.079.014.16.024.24.024.433.002.867.004 1.3-.002.1-.002.203-.029.299-.061a.374.374 0 0 0 .224-.228c.032-.078.07-.155.119-.222a.43.43 0 0 1 .4-.174c.108.009.213.037.32.056.028.005.037.019.04.048.06.732-.503 1.288-1.145 1.37-.16.02-.322.022-.483.022-.44 0-.882.007-1.322-.013a1.326 1.326 0 0 1-1.264-1.15c-.023-.18-.02-.363-.021-.544-.002-.566 0-1.131.001-1.697l-.003-.082c-.096-.008-.188-.013-.279-.024-.561-.07-.961-.36-1.195-.877-.016-.034-.03-.068-.044-.101A.8.8 0 0 1 0 10.348c.003-1.046.002-2.093 0-3.14 0-.064.012-.121.044-.177.092-.159.167-.33.274-.477.25-.346.604-.513 1.03-.526.238-.006.477-.005.715-.005H5.99c.352-.001.665.097.935.327.019.016.05.025.074.025h3.927c.023 0 .052-.009.069-.024.254-.229.555-.327.893-.327.813 0 1.627-.004 2.44-.004.75 0 1.498.003 2.247.004.347.001.658.103.924.328.305.258.463.588.47.987.008.488.015.977.015 1.465 0 .501-.01 1.002-.013 1.503-.003.574-.365 1.03-.858 1.228a1.674 1.674 0 0 1-.585.117c-.044.001-.087.005-.136.008zM13.91 3.87a1.302 1.302 0 0 0 1.285-1.286 1.288 1.288 0 0 0-1.277-1.29 1.304 1.304 0 0 0-1.3 1.284c-.003.688.6 1.29 1.292 1.292zm.013-3.397c1.165-.005 2.089.923 2.094 2.104a2.095 2.095 0 0 1-2.11 2.115c-1.2.002-2.114-.985-2.11-2.126C11.8 1.4 12.73.478 13.923.472zM2.785 2.58c0 .695.591 1.288 1.284 1.289.7 0 1.292-.594 1.292-1.295 0-.7-.585-1.279-1.294-1.28A1.294 1.294 0 0 0 2.785 2.58zm1.288 2.112c-1.176.002-2.105-.937-2.107-2.13-.002-1.167.926-2.086 2.112-2.09a2.087 2.087 0 0 1 2.104 2.106 2.105 2.105 0 0 1-2.109 2.114zm3.571-1.129c0 .74.603 1.35 1.336 1.349.742 0 1.356-.611 1.354-1.347a1.372 1.372 0 0 0-1.35-1.344 1.36 1.36 0 0 0-1.34 1.342zm1.338 2.111A2.083 2.083 0 0 1 6.88 3.568 2.099 2.099 0 0 1 9 1.456a2.112 2.112 0 0 1 2.098 2.12 2.095 2.095 0 0 1-2.116 2.098z"
    />
  </svg>
)

const Support = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <defs>
      <path id="a" d="M0 0h24v24H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <g>
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          className={props.isActive ? style.fillActive : style.fillDefault}
          d="M18.169 6.614l.639-.463a1.609 1.609 0 0 0-.19-.466 1.608 1.608 0 0 0-.308-.397l-.724.323a.407.407 0 0 1-.435-.066 2.667 2.667 0 0 0-.917-.53.407.407 0 0 1-.275-.344l-.082-.788a1.609 1.609 0 0 0-.498-.068c-.235 0-.407.036-.499.068l-.081.788a.408.408 0 0 1-.276.344 2.664 2.664 0 0 0-.916.53.407.407 0 0 1-.436.066l-.723-.324a1.608 1.608 0 0 0-.308.398c-.118.203-.172.37-.19.466l.639.463c.129.093.192.254.16.41a2.71 2.71 0 0 0-.001 1.064.408.408 0 0 1-.16.41l-.639.462c.02.095.073.262.19.465.118.203.235.334.309.398l.718-.321a.407.407 0 0 1 .436.067c.271.24.581.42.922.534.151.05.259.185.275.344l.081.78c.092.032.265.068.499.068.234 0 .406-.036.498-.068l.081-.78a.407.407 0 0 1 .276-.344c.34-.115.65-.295.922-.534a.407.407 0 0 1 .436-.067l.718.32c.073-.063.19-.194.308-.397.117-.203.171-.37.19-.466l-.638-.462a.407.407 0 0 1-.16-.41 2.697 2.697 0 0 0-.002-1.063.407.407 0 0 1 .16-.41M13.644 19.39a.55.55 0 0 0-.01-.101c0-.005-.002-.005-.003-.01a.494.494 0 0 0-.487-.38h-1.329a.499.499 0 1 0 0 .995h1.329c.275 0 .5-.228.5-.504M21 11.886v1.858c0 .693-.545 1.262-1.238 1.262h-.753a7 7 0 0 1-1.167 2.196 6.885 6.885 0 0 1-3.39 2.304 1.322 1.322 0 0 1-1.31 1.204h-1.328a1.315 1.315 0 0 1-1.315-1.313c0-.725.59-1.313 1.315-1.313h1.329c.477 0 .896.248 1.126.629a6.023 6.023 0 0 0 4.236-5.765c0-.82-.161-1.613-.48-2.36l-.536-.24c-.23.175-.48.32-.746.432l-.067.644c-.022.424-.515.686-1.297.686-.784 0-1.277-.263-1.297-.688l-.067-.642a3.463 3.463 0 0 1-.746-.432l-.593.265c-.378.192-.851-.104-1.242-.78a2.414 2.414 0 0 1-.284-.717c-.088-.456.096-.662.23-.75l.527-.382a3.528 3.528 0 0 1 0-.858l-.526-.381c-.358-.23-.34-.789.053-1.468.39-.676.864-.973 1.242-.78l.599.267c.228-.172.476-.315.74-.427l.067-.649c.02-.425.513-.688 1.297-.688.782 0 1.275.262 1.297.687l.067.65c.263.112.51.255.74.427l.597-.266c.143-.073.414-.129.765.175.167.146.337.36.478.605.391.677.411 1.235.055 1.466l-.528.382a3.535 3.535 0 0 1 0 .858l.528.383c.356.23.336.79-.055 1.466-.14.244-.31.459-.478.605h-.001c.316.8.476 1.645.476 2.513 0 .42-.037.833-.11 1.24h.552c.243 0 .423-.204.423-.447v-1.858c0-.19-.12-.363-.301-.42a.404.404 0 0 1-.256-.514.403.403 0 0 1 .508-.263c.522.169.864.65.864 1.197m-4.886-4.327a.736.736 0 1 0-1.472.002.736.736 0 0 0 1.472-.002m.815 0c0 .855-.696 1.55-1.55 1.55-.855 0-1.55-.695-1.55-1.55 0-.855.695-1.55 1.55-1.55.854 0 1.55.695 1.55 1.55m-7.554-.232c-2.302.893-3.84 3.152-3.84 5.621v1.645c0 .225-.2.413-.425.413h-.85c-.692 0-1.26-.57-1.26-1.262v-1.858c0-.548.353-1.028.875-1.196a.408.408 0 0 1 .25.776.45.45 0 0 0-.31.42v1.858a.45.45 0 0 0 .446.447h.46V12.95c0-1.408.415-2.76 1.217-3.91a6.808 6.808 0 0 1 3.134-2.471.407.407 0 0 1 .527.232.403.403 0 0 1-.224.527"
          mask="url(#b)"
        />
      </g>
    </g>
  </svg>
)

const Cart = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        className={props.isActive ? style.fillActive : style.fillDefault}
        d="M16.75 21.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm-6 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zM2.5 2.5h3.51c.27 0 .561.214.647.47L8.5 8.5 7 7.5 5.672 3.959a.756.756 0 0 0-.667-.459H2.5v-1z"
      />
      <path
        className={props.isActive ? style.strokeActive : style.strokeDefault}
        d="M7.58 8l1.118 7.45c.127.844.947 1.55 1.794 1.55h7.016c.857 0 1.725-.714 1.892-1.55L20.89 8H7.58z"
      />
    </g>
  </svg>
)

const Play = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" onClick={props.onClick}>
    <path
      fill="#FFF"
      className={props.isActive ? style.playIconActive : style.playIconDefault}
      fillRule="evenodd"
      d="M21 12L7 20V4z"
    />
  </svg>
)

const PlayDashboard = (props?: IIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={props.onClick}
  >
    <path
      d="M7.39453 19.6074C7.74609 19.6074 8.04492 19.4668 8.39648 19.2646L18.6445 13.3408C19.374 12.9102 19.6289 12.6289 19.6289 12.1631C19.6289 11.6973 19.374 11.416 18.6445 10.9941L8.39648 5.06152C8.04492 4.85938 7.74609 4.72754 7.39453 4.72754C6.74414 4.72754 6.33984 5.21973 6.33984 5.98438V18.3418C6.33984 19.1064 6.74414 19.6074 7.39453 19.6074ZM7.84277 17.9287C7.79004 17.9287 7.75488 17.8936 7.75488 17.8232V6.50293C7.75488 6.43262 7.79004 6.39746 7.84277 6.39746C7.87793 6.39746 7.91309 6.41504 7.94824 6.44141L17.6777 12.0664C17.7217 12.0928 17.7568 12.1191 17.7568 12.1631C17.7568 12.207 17.7217 12.2422 17.6777 12.2598L7.94824 17.8936C7.91309 17.9111 7.87793 17.9287 7.84277 17.9287Z"
      fill="white"
      className={props.isActive ? style.fillActive : style.fillDefault}
    />
  </svg>
)

const PlayCircled = (props?: IIconProps) => (
  <div className={style.playCircled}>
    <svg width="13" height="13" viewBox="0 0 22 22" onClick={props.onClick}>
      <path
        fill="#FFF"
        className={props.isActive ? style.playIconActive : style.playIconDefault}
        fillRule="evenodd"
        d="M21 12L7 20V4z"
      />
    </svg>
  </div>
)

const Phone = () => (
  <svg width="32" height="32" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path d="M1.5 2h20v20h-20z" />
      <path
        className={style.strokeDefaultPhone}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.152 9.406c-.265.489-.225 1.248.094 1.704l1.721 2.458c.317.452 1.007.754 1.57.671l1.832-.272c.27-.04.657.073.871.26l1.6 1.387a1.46 1.46 0 0 1 .113 2.097l-.41.447c-.93 1.016-2.623 1.221-3.738.405 0 0-2.165-1.104-4.746-4.79-2.581-3.686-2.884-6.117-2.884-6.117-.354-1.327.391-2.83 1.664-3.356l.56-.232a1.463 1.463 0 0 1 1.932.824l.758 1.977c.1.261.076.666-.055.908l-.882 1.629z"
      />
    </g>
  </svg>
)

interface DotProps extends IIconProps {
  theme?: 'primary' | 'black'
}

const Dot = (props?: DotProps) => {
  const theme = {
    primary: props.isActive ? style.onlineIconActive : style.offlineIconDefault,
    black: props.isActive ? style.dotActive : style.dotDefault,
  }

  return (
    <svg width="12" height="12" viewBox="0 0 12 12" className={props.className}>
      <circle className={theme[props.theme || 'primary']} cx="6" cy="6" r="3" fillRule="evenodd" />
    </svg>
  )
}

const DotBig = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <circle
      className={props.isActive ? style.onlineIconActive : style.offlineIconDefault}
      cx="12"
      cy="12"
      r="3"
      fillRule="evenodd"
    />
  </svg>
)

const Pod = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        className={props.isActive ? style.strokeActive : style.strokeDefault}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.378 19.657c-1.037-1.628-2.923-4.818-3.732-6.433a2.424 2.424 0 0 1-.008-2.174c.842-1.734 2.616-4.784 3.688-6.46a2.373 2.373 0 0 1 1.885-1.098c1.83-.104 5.58-.135 7.409-.025.778.046 1.434.454 1.892 1.085 1.091 1.502 2.906 4.657 3.732 6.433.328.704.35 1.477.008 2.175-.833 1.692-2.66 4.93-3.688 6.458-.434.647-1.107 1.052-1.885 1.099-1.872.113-5.569.113-7.408.025a2.348 2.348 0 0 1-1.893-1.085z"
      />
      <path
        className={props.isActive ? style.fillActive : style.fillDefault}
        d="M10.817 9.732a.951.951 0 1 1-1.902 0 .951.951 0 0 1 1.902 0"
      />
    </g>
  </svg>
)

const Mobile = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g
      className={props.isActive ? style.strokeActive : style.strokeDefault}
      fill="none"
      fillRule="evenodd"
      transform="translate(6.5 3)"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M.92 13.99h9.66" />
      <rect width="10.5" height="17" x=".5" y=".5" rx=".9" />
    </g>
  </svg>
)

const Clock = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" transform="rotate(-60 11.817 12.683)">
      <circle
        className={props.isActive ? style.strokeActive : style.strokeDefault}
        cx="12.5"
        cy="12.5"
        r="8.5"
        transform="rotate(-30 12.5 12.5)"
      />
      <path
        className={props.isActive ? style.strokeActive : style.strokeDefault}
        d="M17.728 15.52a.5.5 0 0 0 .657-.245.498.498 0 0 0-.234-.66l-5.228-2.438-.423.906 5.228 2.438zM13.71 7.585a.501.501 0 0 0-.426-.557.496.496 0 0 0-.564.418l-.645 4.591.99.14.646-4.592z"
      />
      <circle
        className={props.isActive ? style.strokeActive : style.strokeDefault}
        cx="12.5"
        cy="12.5"
        r="1"
      />
    </g>
  </svg>
)

const Key = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" transform="matrix(-1 0 0 1 20.5 3.5)">
      <path
        className={props.isActive ? style.strokeActive : style.strokeDefault}
        d="M.5 13.715V16.5H3v-2h2v-2h2.29l2.755-2.805.291.091a4.75 4.75 0 1 0-3.051-2.912l.112.309L.5 13.715z"
      />
      <circle
        className={props.isActive ? style.strokeActive : style.strokeDefault}
        cx="12.5"
        cy="4"
        r="1"
      />
    </g>
  </svg>
)

const Attention = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        className={props.isActive ? style.strokeActive : style.strokeDefault}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 2c-2.76 0-5.117.977-7.07 2.93C2.977 6.883 2 9.24 2 12c0 2.76.977 5.117 2.93 7.07C6.883 21.023 9.24 22 12 22c2.76 0 5.117-.977 7.07-2.93C21.023 17.117 22 14.76 22 12c0-2.76-.977-5.117-2.93-7.07C17.117 2.977 14.76 2 12 2z"
      />
      <circle
        className={props.isActive ? style.fillActive : style.fillDefault}
        cx="12"
        cy="17"
        r="1"
      />
      <rect
        className={props.isActive ? style.fillActive : style.fillDefault}
        width="2"
        height="9"
        x="11"
        y="6"
        rx="1"
      />
    </g>
  </svg>
)

const Attention2 = (props?: IIconProps) => (
  <svg width="12" height="12" viewBox="0 0 12 12">
    <g fill="none" fillRule="evenodd" transform="translate(2.000000, 2.000000)">
      <path
        className={props.isActive ? style.fillActive : style.offlineIconDefault}
        d="M4 0C2.896 0 1.953.39 1.172 1.172A3.854 3.854 0 0 0 0 4c0 1.104.39 2.047 1.172 2.828A3.854 3.854 0 0 0 4 8c1.104 0 2.047-.39 2.828-1.172A3.854 3.854 0 0 0 8 4c0-1.104-.39-2.047-1.172-2.828A3.854 3.854 0 0 0 4 0z"
      />
      <circle cx="4" cy="6" r="1" fill="#FFF" />
      <rect width="1" height="3.6" x="3.6" y="1.6" fill="#FFF" rx=".5" />
    </g>
  </svg>
)

const Plume = (props?: IIconProps) => (
  <svg width={props.width || 24} height={props.height || 24} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <path
        className={props.isActive ? style.strokeActive : style.strokeDefault}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.378 19.657c-1.037-1.628-2.923-4.818-3.732-6.433a2.424 2.424 0 0 1-.008-2.174c.842-1.734 2.616-4.784 3.688-6.46a2.373 2.373 0 0 1 1.885-1.098c1.83-.104 5.58-.135 7.409-.025.778.046 1.434.454 1.892 1.085 1.091 1.502 2.906 4.657 3.732 6.433.328.704.35 1.477.008 2.175-.833 1.692-2.66 4.93-3.688 6.458-.434.647-1.107 1.052-1.885 1.099-1.872.113-5.569.113-7.408.025a2.348 2.348 0 0 1-1.893-1.085z"
      />
      <path
        className={props.isActive ? style.fillActive : style.fillDefault}
        d="M10.817 9.732a.951.951 0 1 1-1.902 0 .951.951 0 0 1 1.902 0"
      />
    </g>
  </svg>
)

const LeftArrow = (props?: IIconProps) => {
  const width = props.width || 7
  const height = props.width || 10
  const strokeWidth = props.strokeWidth || '2'
  return (
    <svg width={width} height={height} viewBox="0 0 7 10" onClick={props.onClick}>
      <path
        className={
          props.className
            ? props.className
            : props.isActive
            ? style.strokeActive
            : style.strokeDefault
        }
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeWidth={strokeWidth}
        d="M6 1L2 5l4 4"
      />
    </svg>
  )
}

const LeftDoubleArrow = (props?: IIconProps) => (
  <svg width="13" height="10" viewBox="0 0 13 10" onClick={props.onClick}>
    <g
      fill="none"
      fillRule="evenodd"
      className={
        props.className
          ? props.className
          : props.isActive
          ? style.strokeActive
          : style.strokeDefault
      }
      strokeLinecap="round"
      strokeWidth="2"
    >
      <path d="M6 1L2 5l4 4M12 1L8 5l4 4" />
    </g>
  </svg>
)

const RightArrow = (props?: IIconProps) => {
  const width = props.width || 7
  const height = props.width || 10
  const viewBox = `0 0 ${width} ${height}`
  return (
    <svg width={width} height={height} viewBox={viewBox} onClick={props.onClick}>
      <path
        className={
          props.className
            ? props.className
            : props.isActive
            ? style.strokeActive
            : style.strokeDefault
        }
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeWidth="2"
        d="M1 1l4 4-4 4"
      />
    </svg>
  )
}

const RightDoubleArrow = (props?: IIconProps) => (
  <svg width="13" height="10" viewBox="0 0 13 10" onClick={props.onClick}>
    <g
      className={
        props.className
          ? props.className
          : props.isActive
          ? style.strokeActive
          : style.strokeDefault
      }
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeWidth="2"
    >
      <path d="M7 1l4 4-4 4M1 1l4 4-4 4" />
    </g>
  </svg>
)

const DownArrow = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" onClick={props.onClick}>
    <path
      className={props.isActive ? style.fillActive : style.fillDefault}
      fillRule="evenodd"
      d="M16.6 8.6L12 13.2 7.4 8.6 6 10l6 6 6-6z"
    />
  </svg>
)

const UpArrow = (props?: IIconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" transform="rotate(180)" onClick={props.onClick}>
    <path
      className={props.isActive ? style.fillActive : style.fillDefault}
      fillRule="evenodd"
      d="M16.6 8.6L12 13.2 7.4 8.6 6 10l6 6 6-6z"
    />
  </svg>
)

const CircledLogo = (props?: IIconProps) => {
  const width = props.width ? props.width : '50px'
  const height = props.height ? props.height : '50px'
  return (
    <svg width={width} height={height} viewBox="0 0 50 50">
      <g fill="none" fillRule="evenodd" transform="translate(1 1)">
        <circle cx="24" cy="24" r="24" stroke="#803FCE" />
        <path
          fill="#803FCE"
          d="M31.792 24.777l-.001-.002a1.372 1.372 0 0 1-.003 1.37l.001-.001-3.478 6.01a3.325 3.325 0 0 1-2.878 1.656l-7.83-.002c-.285 0-.55.194-.595.474a.571.571 0 0 0 .564.667l7.86.002a4.47 4.47 0 0 0 3.87-2.227l3.478-6.01v-.001a2.515 2.515 0 0 0 .004-2.505l-.002-.001-2.892-5.001a.412.412 0 0 0-.357-.206h-.907a.103.103 0 0 0-.089.154l3.255 5.623z"
        />
        <path
          fill="#803FCE"
          d="M26.018 31.051v-.002a1.373 1.373 0 0 1-1.19.683h.002-6.957a3.325 3.325 0 0 1-2.877-1.658l-3.912-6.763c-.15-.259-.472-.387-.745-.264a.57.57 0 0 0-.262.806l3.928 6.792a4.47 4.47 0 0 0 3.868 2.228h6.959a2.532 2.532 0 0 0 2.176-1.25v-.001l2.896-5a.41.41 0 0 0 0-.41l-.453-.784a.103.103 0 0 0-.178 0l-3.255 5.623z"
        />
        <path
          fill="#803FCE"
          d="M18.252 28.655h.002a1.379 1.379 0 0 1-1.187-.687v.001l-3.478-6.01a3.308 3.308 0 0 1 0-3.314l3.918-6.763c.142-.246.106-.57-.115-.75a.573.573 0 0 0-.86.153l-3.933 6.79a4.446 4.446 0 0 0-.001 4.455l3.479 6.01v.001a2.522 2.522 0 0 0 2.173 1.255h.002l5.789.002a.412.412 0 0 0 .356-.206l.454-.783a.103.103 0 0 0-.09-.154h-6.509z"
        />
        <path
          fill="#803FCE"
          d="M16.325 21.174v.002a1.37 1.37 0 0 1 .003-1.37v.002l3.478-6.01a3.325 3.325 0 0 1 2.878-1.657l7.83.003c.285 0 .549-.194.595-.475a.571.571 0 0 0-.564-.667L22.685 11a4.47 4.47 0 0 0-3.87 2.227l-3.478 6.01-.001.001a2.515 2.515 0 0 0-.003 2.505l.001.002 2.893 5c.073.128.21.206.356.206h.907c.08 0 .129-.085.09-.154l-3.255-5.623z"
        />
        <path
          fill="#803FCE"
          d="M21.941 15.822v.002a1.376 1.376 0 0 1 1.19-.683h-.002 6.957c1.187 0 2.284.632 2.878 1.658l3.911 6.763c.15.259.473.387.745.264a.57.57 0 0 0 .262-.806l-3.928-6.791A4.47 4.47 0 0 0 30.086 14h-6.958a2.532 2.532 0 0 0-2.176 1.25l-.001.002-2.896 4.999a.41.41 0 0 0 0 .41l.453.784c.04.068.14.068.179 0l3.254-5.623z"
        />
        <path
          fill="#803FCE"
          d="M29.612 17.143h-.002a1.382 1.382 0 0 1 1.188.687v-.002l3.478 6.01a3.308 3.308 0 0 1 0 3.315l-3.918 6.763c-.142.246-.106.57.115.75.281.23.687.147.86-.154l3.933-6.789a4.446 4.446 0 0 0 0-4.455l-3.478-6.01v-.001a2.522 2.522 0 0 0-2.174-1.255h-.002L23.824 16a.412.412 0 0 0-.357.205l-.453.784c-.04.068.01.154.09.154h6.508z"
        />
      </g>
    </svg>
  )
}

const LogoBronze = (props?: IIconProps) => {
  const width = props.width ? props.width : '82px'
  const height = props.height ? props.height : '82px'
  return (
    <svg width={width} height={height} viewBox="0 0 82 82">
      <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#DDD9CD" />
          <stop offset="100%" stopColor="#B8B29E" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(1 1)">
        <circle cx="40" cy="40" r="40" stroke="url(#a)" strokeWidth="2" />
        <path
          fill="url(#a)"
          d="M52.986 41.295l-.002-.003a2.286 2.286 0 0 1-.004 2.283l.002-.002-5.798 10.016a5.542 5.542 0 0 1-4.796 2.761l-13.05-.004c-.475 0-.915.324-.992.79a.952.952 0 0 0 .94 1.112l13.101.004a7.449 7.449 0 0 0 6.448-3.712l5.798-10.017.001-.002a4.191 4.191 0 0 0 .005-4.174l-.002-.003-4.82-8.335a.686.686 0 0 0-.595-.342h-1.511a.171.171 0 0 0-.149.256l5.424 9.372z"
        />
        <path
          fill="url(#a)"
          d="M43.363 51.752l.002-.003a2.288 2.288 0 0 1-1.984 1.138h.002-11.595a5.542 5.542 0 0 1-4.795-2.763l-6.52-11.273c-.249-.43-.787-.644-1.241-.44a.95.95 0 0 0-.437 1.344l6.546 11.32a7.449 7.449 0 0 0 6.447 3.714h11.598a4.22 4.22 0 0 0 2.096-.562 4.195 4.195 0 0 0 1.53-1.521l.002-.003 4.826-8.332a.684.684 0 0 0 0-.685l-.755-1.306a.172.172 0 0 0-.297 0l-5.425 9.372z"
        />
        <path
          fill="url(#a)"
          d="M30.42 47.759h.004a2.298 2.298 0 0 1-1.98-1.146l.001.003L22.648 36.6a5.513 5.513 0 0 1 0-5.525l6.53-11.271c.237-.41.176-.952-.191-1.252a.955.955 0 0 0-1.435.257l-6.554 11.315a7.41 7.41 0 0 0-.001 7.426l5.797 10.017.001.002a4.204 4.204 0 0 0 3.622 2.091h.004l9.647.003c.245 0 .472-.13.594-.342l.756-1.306a.171.171 0 0 0-.149-.256H30.421z"
        />
        <path
          fill="url(#a)"
          d="M27.208 35.29l.001.003a2.283 2.283 0 0 1 .005-2.283l-.002.003 5.798-10.017a5.542 5.542 0 0 1 4.796-2.761l13.05.004c.475 0 .915-.323.992-.79a.952.952 0 0 0-.94-1.112l-13.101-.004a7.45 7.45 0 0 0-6.448 3.712L25.56 32.062l-.001.002a4.191 4.191 0 0 0-.005 4.174l.002.003 4.82 8.335c.123.212.35.343.595.343h1.512a.171.171 0 0 0 .148-.257l-5.424-9.372z"
        />
        <path
          fill="url(#a)"
          d="M36.57 26.37l-.003.003a2.294 2.294 0 0 1 1.984-1.138h-.002 11.595a5.542 5.542 0 0 1 4.795 2.763l6.52 11.273c.25.43.787.644 1.242.44a.95.95 0 0 0 .436-1.344l-6.546-11.32a7.45 7.45 0 0 0-6.447-3.714H38.546a4.22 4.22 0 0 0-2.096.562 4.193 4.193 0 0 0-1.53 1.521l-.002.003-4.826 8.332a.683.683 0 0 0 0 .685l.755 1.306a.172.172 0 0 0 .298 0l5.424-9.372z"
        />
        <path
          fill="url(#a)"
          d="M49.354 28.571h-.004a2.303 2.303 0 0 1 1.98 1.145l-.001-.002 5.798 10.016a5.513 5.513 0 0 1-.001 5.524l-6.53 11.272c-.237.41-.176.952.192 1.252a.955.955 0 0 0 1.435-.257l6.554-11.315a7.41 7.41 0 0 0 0-7.426L52.98 28.763v-.002a4.204 4.204 0 0 0-3.623-2.091h-.003l-9.647-.003a.687.687 0 0 0-.595.342l-.755 1.306a.171.171 0 0 0 .148.256h10.849z"
        />
      </g>
    </svg>
  )
}

const LogoSilver = (props?: IIconProps) => {
  const width = props.width ? props.width : '82px'
  const height = props.height ? props.height : '82px'
  return (
    <svg width={width} height={height} viewBox="-1 -1 82 82">
      <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#E3E4E4" />
          <stop offset="100%" stopColor="#C3C4C5" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle cx="40" cy="40" r="40" stroke="url(#a)" strokeWidth="2" />
        <path
          fill="#C3C4C5"
          d="M52.986 41.295l-.002-.003a2.286 2.286 0 0 1-.004 2.283l.002-.002-5.798 10.016a5.542 5.542 0 0 1-4.796 2.761l-13.05-.004c-.475 0-.915.324-.992.79a.952.952 0 0 0 .94 1.112l13.101.004a7.449 7.449 0 0 0 6.448-3.712l5.798-10.017.001-.002a4.191 4.191 0 0 0 .005-4.174l-.002-.003-4.82-8.335a.686.686 0 0 0-.595-.342h-1.511a.171.171 0 0 0-.149.256l5.424 9.372z"
        />
        <path
          fill="#C3C4C5"
          d="M43.363 51.752l.002-.003a2.288 2.288 0 0 1-1.984 1.138h.002-11.595a5.542 5.542 0 0 1-4.795-2.763l-6.52-11.273c-.249-.43-.787-.644-1.241-.44a.95.95 0 0 0-.437 1.344l6.546 11.32a7.449 7.449 0 0 0 6.447 3.714h11.598a4.22 4.22 0 0 0 2.096-.562 4.195 4.195 0 0 0 1.53-1.521l.002-.003 4.826-8.332a.684.684 0 0 0 0-.685l-.755-1.306a.172.172 0 0 0-.297 0l-5.425 9.372z"
        />
        <path
          fill="#C3C4C5"
          d="M30.42 47.759h.004a2.298 2.298 0 0 1-1.98-1.146l.001.003L22.648 36.6a5.513 5.513 0 0 1 0-5.525l6.53-11.271c.237-.41.176-.952-.191-1.252a.955.955 0 0 0-1.435.257l-6.554 11.315a7.41 7.41 0 0 0-.001 7.426l5.797 10.017.001.002a4.204 4.204 0 0 0 3.622 2.091h.004l9.647.003c.245 0 .472-.13.594-.342l.756-1.306a.171.171 0 0 0-.149-.256H30.421z"
        />
        <path
          fill="#C3C4C5"
          d="M27.208 35.29l.001.003a2.283 2.283 0 0 1 .005-2.283l-.002.003 5.798-10.017a5.542 5.542 0 0 1 4.796-2.761l13.05.004c.475 0 .915-.323.992-.79a.952.952 0 0 0-.94-1.112l-13.101-.004a7.45 7.45 0 0 0-6.448 3.712L25.56 32.062l-.001.002a4.191 4.191 0 0 0-.005 4.174l.002.003 4.82 8.335c.123.212.35.343.595.343h1.512a.171.171 0 0 0 .148-.257l-5.424-9.372z"
        />
        <path
          fill="#C3C4C5"
          d="M36.57 26.37l-.003.003a2.294 2.294 0 0 1 1.984-1.138h-.002 11.595a5.542 5.542 0 0 1 4.795 2.763l6.52 11.273c.25.43.787.644 1.242.44a.95.95 0 0 0 .436-1.344l-6.546-11.32a7.45 7.45 0 0 0-6.447-3.714H38.546a4.22 4.22 0 0 0-2.096.562 4.193 4.193 0 0 0-1.53 1.521l-.002.003-4.826 8.332a.683.683 0 0 0 0 .685l.755 1.306a.172.172 0 0 0 .298 0l5.424-9.372z"
        />
        <path
          fill="#C3C4C5"
          d="M49.354 28.571h-.004a2.303 2.303 0 0 1 1.98 1.145l-.001-.002 5.798 10.016a5.513 5.513 0 0 1-.001 5.524l-6.53 11.272c-.237.41-.176.952.192 1.252a.955.955 0 0 0 1.435-.257l6.554-11.315a7.41 7.41 0 0 0 0-7.426L52.98 28.763v-.002a4.204 4.204 0 0 0-3.623-2.091h-.003l-9.647-.003a.687.687 0 0 0-.595.342l-.755 1.306a.171.171 0 0 0 .148.256h10.849z"
        />
      </g>
    </svg>
  )
}

const LogoGold = (props?: IIconProps) => {
  const width = props.width ? props.width : '82px'
  const height = props.height ? props.height : '82px'
  return (
    <svg width={width} height={height} viewBox="-1 -1 82 82">
      <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#F2ECD3" />
          <stop offset="100%" stopColor="#E1D4A8" />
        </linearGradient>
        <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#F2ECD3" />
          <stop offset="100%" stopColor="#E1D4A8" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle cx="40" cy="40" r="40" stroke="url(#a)" strokeWidth="2" />
        <path
          fill="url(#b)"
          d="M52.986 41.295l-.002-.003a2.286 2.286 0 0 1-.004 2.283l.002-.002-5.798 10.016a5.542 5.542 0 0 1-4.796 2.761l-13.05-.004c-.475 0-.915.324-.992.79a.952.952 0 0 0 .94 1.112l13.101.004a7.449 7.449 0 0 0 6.448-3.712l5.798-10.017.001-.002a4.191 4.191 0 0 0 .005-4.174l-.002-.003-4.82-8.335a.686.686 0 0 0-.595-.342h-1.511a.171.171 0 0 0-.149.256l5.424 9.372z"
        />
        <path
          fill="url(#b)"
          d="M43.363 51.752l.002-.003a2.288 2.288 0 0 1-1.984 1.138h.002-11.595a5.542 5.542 0 0 1-4.795-2.763l-6.52-11.273c-.249-.43-.787-.644-1.241-.44a.95.95 0 0 0-.437 1.344l6.546 11.32a7.449 7.449 0 0 0 6.447 3.714h11.598a4.22 4.22 0 0 0 2.096-.562 4.195 4.195 0 0 0 1.53-1.521l.002-.003 4.826-8.332a.684.684 0 0 0 0-.685l-.755-1.306a.172.172 0 0 0-.297 0l-5.425 9.372z"
        />
        <path
          fill="url(#b)"
          d="M30.42 47.759h.004a2.298 2.298 0 0 1-1.98-1.146l.001.003L22.648 36.6a5.513 5.513 0 0 1 0-5.525l6.53-11.271c.237-.41.176-.952-.191-1.252a.955.955 0 0 0-1.435.257l-6.554 11.315a7.41 7.41 0 0 0-.001 7.426l5.797 10.017.001.002a4.204 4.204 0 0 0 3.622 2.091h.004l9.647.003c.245 0 .472-.13.594-.342l.756-1.306a.171.171 0 0 0-.149-.256H30.421z"
        />
        <path
          fill="url(#b)"
          d="M27.208 35.29l.001.003a2.283 2.283 0 0 1 .005-2.283l-.002.003 5.798-10.017a5.542 5.542 0 0 1 4.796-2.761l13.05.004c.475 0 .915-.323.992-.79a.952.952 0 0 0-.94-1.112l-13.101-.004a7.45 7.45 0 0 0-6.448 3.712L25.56 32.062l-.001.002a4.191 4.191 0 0 0-.005 4.174l.002.003 4.82 8.335c.123.212.35.343.595.343h1.512a.171.171 0 0 0 .148-.257l-5.424-9.372z"
        />
        <path
          fill="url(#b)"
          d="M36.57 26.37l-.003.003a2.294 2.294 0 0 1 1.984-1.138h-.002 11.595a5.542 5.542 0 0 1 4.795 2.763l6.52 11.273c.25.43.787.644 1.242.44a.95.95 0 0 0 .436-1.344l-6.546-11.32a7.45 7.45 0 0 0-6.447-3.714H38.546a4.22 4.22 0 0 0-2.096.562 4.193 4.193 0 0 0-1.53 1.521l-.002.003-4.826 8.332a.683.683 0 0 0 0 .685l.755 1.306a.172.172 0 0 0 .298 0l5.424-9.372z"
        />
        <path
          fill="url(#b)"
          d="M49.354 28.571h-.004a2.303 2.303 0 0 1 1.98 1.145l-.001-.002 5.798 10.016a5.513 5.513 0 0 1-.001 5.524l-6.53 11.272c-.237.41-.176.952.192 1.252a.955.955 0 0 0 1.435-.257l6.554-11.315a7.41 7.41 0 0 0 0-7.426L52.98 28.763v-.002a4.204 4.204 0 0 0-3.623-2.091h-.003l-9.647-.003a.687.687 0 0 0-.595.342l-.755 1.306a.171.171 0 0 0 .148.256h10.849z"
        />
      </g>
    </svg>
  )
}

const Checked = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <circle cx="12" cy="12" r="12" fill="#6269FF" />
      <path
        stroke="#FFF"
        strokeLinecap="square"
        strokeWidth="3"
        d="M15.869 8.8l-5.258 6.241L8.2 12.77"
      />
    </g>
  </svg>
)

const Plus = (props?: IIconProps) => {
  const width = props.width ? props.width : '24px'
  const height = props.height ? props.height : '24px'
  return (
    <svg width={width} height={height} viewBox="0 0 24 24">
      <g
        fill="none"
        fillRule="evenodd"
        stroke="#3C396F"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="rotate(45 12 12)"
      >
        <path d="M6 6.5l12.374 12.374M6 18.872L18.377 6.5" />
      </g>
    </svg>
  )
}

const Minus = (props?: IIconProps) => {
  const width = props.width ? props.width : '24px'
  const height = props.height ? props.height : '24px'
  return (
    <svg width={width} height={height} viewBox="0 0 14 2">
      <path
        fill="none"
        fillRule="evenodd"
        stroke="#939597"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1.291 1.125h11.667"
      />
    </svg>
  )
}

export const MinusRounded = (props?: IIconProps) => {
  return (
    <svg className={props.className} width="33" height="32" viewBox="0 0 33 32">
      <g fill="none" fillRule="evenodd" transform="translate(.5)">
        <circle cx="16.5" cy="16" r="16" fill="#6269FF"></circle>
        <path
          fill="#FFF"
          d="M 8.333 15.093 L 8.333 16.907 L 15.593 16.907 L 17.407 16.907 L 24.667 16.907 L 24.667 15.093 L 17.407 15.093 L 8.333 15.093 z"
        ></path>
      </g>
    </svg>
  )
}

const Download = () => {
  return (
    <svg width="9" height="12" viewBox="0 0 9 12">
      <path
        fill="#6269FF"
        fillRule="nonzero"
        d="M4 .5v6.793L1.703 5A.498.498 0 0 0 1 5.703l3.147 3.15a.5.5 0 0 0 .707 0l3.148-3.148A.497.497 0 0 0 8 5a.503.503 0 0 0-.709.002L5 7.293V.5a.5.5 0 0 0-1 0zm-4 11a.5.5 0 0 0 .5.5h8a.5.5 0 1 0 0-1h-8a.5.5 0 0 0-.5.5z"
      />
    </svg>
  )
}

const Settings = (props?: IIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className || style.settingsDefaultPadding}
    >
      <path
        fill="#3C396F"
        className={props.isActive ? style.fillActive : style.fillDefault}
        fillRule="evenodd"
        d="M7.73146 0C7.39897 0 7.11327 0.235992 7.05048 0.5625L6.63942 2.61779C5.97957 2.8774 5.38462 3.24249 4.84375 3.67788L2.83173 2.98558L2.29087 2.8125L2.00962 3.3101L0.625 5.6899L0.34375 6.1875L0.754808 6.55529L2.3125 7.91827C2.25571 8.27254 2.18269 8.6268 2.18269 9C2.18269 9.3732 2.25571 9.72746 2.3125 10.0817L0.754808 11.4447L0.34375 11.8125L0.625 12.3101L2.00962 14.6899L2.29087 15.1875L2.83173 15.0144L4.84375 14.3221C5.38462 14.7575 5.97957 15.1226 6.63942 15.3822L7.05048 17.4375L7.15865 18H11.0529L11.1611 17.4375L11.5721 15.3822C12.232 15.1226 12.8269 14.7575 13.3678 14.3221L15.3798 15.0144L15.9207 15.1875L16.2019 14.6899L17.5865 12.3101L17.8678 11.8125L17.4567 11.4447L15.899 10.0817C15.9558 9.72746 16.0288 9.3732 16.0288 9C16.0288 8.6268 15.9558 8.27254 15.899 7.91827L17.4567 6.55529L17.8678 6.1875L17.5865 5.6899L16.2019 3.3101L15.9207 2.8125L15.3798 2.98558L13.3678 3.67788C12.8269 3.24249 12.232 2.8774 11.5721 2.61779L11.1611 0.5625L11.0529 0H7.73146ZM8.28365 1.38462H9.92789L10.274 3.18029L10.3606 3.59135L10.75 3.72115C11.537 3.96725 12.2509 4.38371 12.8486 4.93269L13.1514 5.21394L13.5409 5.08413L15.2933 4.47837L16.1154 5.88462L14.7308 7.11779L14.4062 7.3774L14.5144 7.78846C14.6037 8.18329 14.6442 8.58624 14.6442 9C14.6442 9.41376 14.6037 9.81671 14.5144 10.2115L14.4279 10.6226L14.7308 10.8822L16.1154 12.1154L15.2933 13.5216L13.5409 12.9159L13.1514 12.7861L12.8486 13.0673C12.2509 13.6163 11.537 14.0328 10.75 14.2788L10.3606 14.4087L10.274 14.8197L9.92789 16.6154H8.28365L7.9375 14.8197L7.85096 14.4087L7.46154 14.2788C6.67458 14.0328 5.96064 13.6163 5.36298 13.0673L5.0601 12.7861L4.67067 12.9159L2.91827 13.5216L2.09615 12.1154L3.48077 10.8822L3.80529 10.6226L3.69712 10.2115C3.60787 9.81671 3.56731 9.41376 3.56731 9C3.56731 8.58624 3.60787 8.18329 3.69712 7.78846L3.80529 7.3774L3.48077 7.11779L2.09615 5.88462L2.91827 4.47837L4.67067 5.08413L5.0601 5.21394L5.36298 4.93269C5.96064 4.38371 6.67458 3.96725 7.46154 3.72115L7.85096 3.59135L7.9375 3.18029L8.28365 1.38462ZM9.10577 5.53846C7.20192 5.53846 5.64423 7.09615 5.64423 9C5.64423 10.9038 7.20192 12.4615 9.10577 12.4615C11.0096 12.4615 12.5673 10.9038 12.5673 9C12.5673 7.09615 11.0096 5.53846 9.10577 5.53846ZM9.10577 6.92308C10.2605 6.92308 11.1827 7.84525 11.1827 9C11.1827 10.1547 10.2605 11.0769 9.10577 11.0769C7.95102 11.0769 7.02885 10.1547 7.02885 9C7.02885 7.84525 7.95102 6.92308 9.10577 6.92308Z"
      />
    </svg>
  )
}

const CheckCircled = (props?: IIconProps) => {
  return (
    <svg className={props.className} width="33" height="32" viewBox="0 0 33 32">
      <g fill="none" fillRule="evenodd" stroke="#16E2A8" transform="translate(.5)">
        <circle cx="16" cy="16" r="14" strokeWidth="4" />
        <path strokeLinecap="square" strokeWidth="3" d="M10.658 16l3.246 4 7.1-8" />
      </g>
    </svg>
  )
}

const PlusRounded = (props?: IIconProps) => {
  return (
    <svg className={props.className} width="33" height="32" viewBox="0 0 33 32">
      <g fill="none" fillRule="evenodd" transform="translate(.5)">
        <circle cx="16" cy="16" r="16" fill="#6269FF" />
        <path
          fill="#FFF"
          d="M16.907 7.833h-1.814v7.26h-7.26v1.814h7.26v7.26h1.814v-7.26h7.26v-1.814h-7.26z"
        />
      </g>
    </svg>
  )
}

const PlusRoundedDisabled = (props?: IIconProps) => {
  return (
    <svg className={props.className} width="33" height="32" viewBox="0 0 33 32">
      <g fill="none" fillRule="evenodd" transform="translate(.5)">
        <circle cx="16" cy="16" r="16" fill="rgba(222, 222, 222, 0.67)" />
        <path
          fill="#FFF"
          d="M16.907 7.833h-1.814v7.26h-7.26v1.814h7.26v7.26h1.814v-7.26h7.26v-1.814h-7.26z"
        />
      </g>
    </svg>
  )
}

const InfoButton = (props?: IIconProps) => {
  return (
    <svg
      className={props.className}
      data-name="icons"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <g data-name="icon-info">
        <path d="M12 24a11.61 11.61 0 01-8.48-3.52A11.61 11.61 0 010 12a11.61 11.61 0 013.51-8.48A11.61 11.61 0 0112 0a11.61 11.61 0 018.48 3.52A11.61 11.61 0 0124 12a11.61 11.61 0 01-3.52 8.48A11.61 11.61 0 0112 24zm0-22.59a10.12 10.12 0 00-7.49 3.1A10.12 10.12 0 001.41 12a10.11 10.11 0 003.1 7.49 10.11 10.11 0 007.49 3.1 10.11 10.11 0 007.49-3.1 10.11 10.11 0 003.1-7.49 10.11 10.11 0 00-3.1-7.49A10.11 10.11 0 0012 1.41z" />
        <path d="M10.59 11.09a1.09 1.09 0 01.42-.85 1.55 1.55 0 012 0 1.09 1.09 0 01.42.85v6.05A1.09 1.09 0 0113 18a1.55 1.55 0 01-2 0 1.09 1.09 0 01-.42-.85zM12 7.76c-.38 0-.71-.14-.71-.71a.62.62 0 01-.71-.71c0-.42.14-.75.71-.71 0-.57.32-.71.71-.71s.71.13.71.71c.57 0 .71.29.71.71a.62.62 0 01-.71.71c0 .57-.33.71-.71.71z" />
      </g>
    </svg>
  )
}

const QuestionMarkRounded = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21ZM9.06421 9.79688C9.12134 8.35596 10.1052 7.26416 11.946 7.26416C13.6218 7.26416 14.7517 8.26074 14.7517 9.61914C14.7517 10.603 14.2566 11.2949 13.4187 11.7964C12.5999 12.2788 12.365 12.6152 12.365 13.269V13.6562H11.051L11.0447 13.1484C11.0129 12.2534 11.4001 11.6821 12.2698 11.1616C13.0378 10.6982 13.3108 10.3301 13.3108 9.67627C13.3108 8.95898 12.7458 8.43213 11.8762 8.43213C11.0002 8.43213 10.4353 8.95898 10.3782 9.79688H9.06421ZM11.7175 16.5952C11.2542 16.5952 10.886 16.2397 10.886 15.7764C10.886 15.313 11.2542 14.9575 11.7175 14.9575C12.1936 14.9575 12.5554 15.313 12.5554 15.7764C12.5554 16.2397 12.1936 16.5952 11.7175 16.5952Z"
        fill="white"
      />
    </svg>
  )
}

const KnowledgeCenter: React.FC<IIconProps> = _props => {
  return (
    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
      <path
        // className={props.isActive ? style.fillActive : style.fillSecondaryGrey}
        d="M512 202.667C358.4 202.667 234.667 326.4 234.667 480c0 106.667 59.733 200.533 149.333 245.333v64c0 36.267 27.733 64 64 64h128c36.267 0 64-27.733 64-64v-64C729.6 678.4 789.333 586.667 789.333 480c0-153.6-123.733-277.333-277.333-277.333zm108.8 486.4l-23.467 10.666v89.6c0 12.8-8.533 21.334-21.333 21.334H448c-12.8 0-21.333-8.534-21.333-21.334v-89.6l-23.467-12.8C324.267 646.4 277.333 567.467 277.333 477.867 277.333 347.733 381.867 243.2 512 243.2s234.667 104.533 234.667 234.667c0 89.6-49.067 168.533-125.867 211.2zM597.333 896H426.667c-12.8 0-21.334 8.533-21.334 21.333s8.534 21.334 21.334 21.334h170.666c12.8 0 21.334-8.534 21.334-21.334S610.133 896 597.333 896zM576 981.333H448c-12.8 0-21.333 8.534-21.333 21.334S435.2 1024 448 1024h128c12.8 0 21.333-8.533 21.333-21.333S588.8 981.333 576 981.333zM501.333 128c12.8 0 21.334-8.533 21.334-21.333V21.333c0-12.8-8.534-21.333-21.334-21.333S480 8.533 480 21.333v85.334c0 12.8 8.533 21.333 21.333 21.333zm407.467 6.4c-4.267-4.267-10.667-6.4-14.933-6.4s-10.667 2.133-14.934 6.4L819.2 194.133c-8.533 8.534-8.533 21.334 0 29.867 4.267 4.267 10.667 6.4 14.933 6.4s10.667-2.133 14.934-6.4l59.733-59.733c8.533-8.534 8.533-21.334 0-29.867zm-661.333 59.733L185.6 134.4c-4.267-4.267-8.533-6.4-14.933-6.4s-10.667 2.133-14.934 6.4c-8.533 8.533-8.533 21.333 0 29.867L215.467 224c4.266 4.267 10.666 6.4 14.933 6.4s10.667-2.133 14.933-6.4c10.667-6.4 10.667-21.333 2.134-29.867zm-140.8 243.2H21.333C8.533 437.333 0 445.867 0 458.667S8.533 480 21.333 480h85.334c12.8 0 21.333-8.533 21.333-21.333s-8.533-21.334-21.333-21.334zm896 0h-85.334c-12.8 0-21.333 8.534-21.333 21.334S904.533 480 917.333 480h85.334c12.8 0 21.333-8.533 21.333-21.333s-8.533-21.334-21.333-21.334z"
      />
    </svg>
  )
}

const AccountManager: React.FC<IIconProps> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M8.08879 11.9781C6.39746 11.1028 5.25581 9.3523 5.25581 7.25164C5.25581 4.36324 7.53911 2 10.3298 2C13.1205 2 15.4038 4.36324 15.4038 7.25164C15.4038 10.0963 13.2474 12.4158 10.4989 12.5033H10.4567C6.27061 12.5033 2.84567 16.0481 2.84567 20.3807C2.84567 20.6433 2.67653 20.8184 2.42283 20.8184C2.16913 20.8184 2 20.6433 2 20.3807C2 16.3982 4.57928 13.0284 8.08879 11.9781V11.9781ZM10.3298 11.628C12.6554 11.628 14.5581 9.65864 14.5581 7.25164C14.5581 4.84464 12.6554 2.87527 10.3298 2.87527C8.00423 2.87527 6.10148 4.84464 6.10148 7.25164C6.10148 9.65864 8.00423 11.628 10.3298 11.628ZM21.9154 14.5164L22 14.7352L20.9852 16.0044C20.8161 16.2232 20.8161 16.5733 20.9852 16.7921L22 18.0175L21.9154 18.2363C21.704 18.849 21.408 19.4617 20.9852 19.9431L20.8161 20.1182L19.2516 19.8556C18.9979 19.8118 18.7019 19.9869 18.6173 20.2495L18.0677 21.8249L17.8562 21.8687C17.0529 22.0438 16.2495 22.0438 15.4461 21.8687L15.1924 21.8249L14.685 20.2932C14.6004 20.0306 14.3044 19.8556 14.0507 19.8993L12.444 20.1619L12.2748 19.9869C12.0634 19.7681 11.8943 19.5055 11.7674 19.2429C11.5983 18.9365 11.4292 18.5864 11.3446 18.2363L11.26 18.0175L12.3171 16.7921C12.4863 16.5733 12.4863 16.2232 12.3171 16.0481L11.3023 14.779L11.3869 14.5602C11.5983 13.9037 11.9366 13.3348 12.3594 12.8096L12.5285 12.6346L14.0507 12.8972C14.3044 12.9409 14.6004 12.7659 14.7273 12.5033L15.277 10.9716L15.4884 10.9278C16.2495 10.7527 17.0529 10.7527 17.8562 10.9278L18.1099 10.9716L18.6173 12.4595C18.7019 12.7221 18.9979 12.9409 19.2939 12.8972L20.8583 12.6783L21.0275 12.8534C21.2389 13.116 21.408 13.3348 21.5349 13.6411C21.6617 13.86 21.7886 14.2101 21.9154 14.5164ZM20.7315 13.9912C20.6469 13.8162 20.5624 13.6849 20.4355 13.5098L19.3362 13.6411C18.6596 13.7287 17.9831 13.291 17.7717 12.6346L17.4334 11.628C16.926 11.5405 16.4186 11.5405 15.9112 11.628L15.5307 12.6783C15.3192 13.3348 14.6004 13.7724 13.9239 13.6411L12.8668 13.4661C12.6131 13.7724 12.444 14.1663 12.2748 14.5164L12.9937 15.3917C13.4165 15.9168 13.4165 16.7484 12.9937 17.2735L12.2748 18.1488C12.3594 18.3676 12.444 18.5427 12.5708 18.7615C12.6554 18.9365 12.74 19.0678 12.8668 19.1991L14.0085 19.0241C14.685 18.9365 15.3615 19.3742 15.5729 20.0306L15.9112 21.081C16.4186 21.1685 16.9683 21.1685 17.4757 21.081L17.8562 19.9869C18.0677 19.3304 18.7865 18.8928 19.4207 19.0241L20.4778 19.1991C20.6892 18.8928 20.9006 18.5427 21.0275 18.1488L20.351 17.3173C19.9281 16.7921 19.8858 15.9606 20.3087 15.4354L21.0275 14.5602C20.9429 14.3851 20.8584 14.2101 20.7315 13.9912V13.9912ZM16.6723 18.3676C15.6152 18.3676 14.7696 17.4923 14.7696 16.3982C14.7696 15.3042 15.6152 14.4289 16.6723 14.4289C17.7294 14.4289 18.5751 15.3042 18.5751 16.3982C18.5751 17.4923 17.6871 18.3676 16.6723 18.3676ZM16.6723 17.4923C17.2643 17.4923 17.7294 17.0109 17.7294 16.3982C17.7294 15.7856 17.2643 15.3042 16.6723 15.3042C16.0803 15.3042 15.6152 15.7856 15.6152 16.3982C15.6152 17.0109 16.0803 17.4923 16.6723 17.4923Z"
        className={props.isActive ? style.fillActive : style.fillDefault}
      />
    </svg>
  )
}

const CopyToClipboardIcon = (props?: IIconProps) => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="#999c9e"
        d="M559.986 480c10.666 0 16.014 5.348 16.014 16.014v31.972C576 538.68 570.652 544 559.986 544h-224C325.319 544 320 538.652 320 527.986v-31.972C320 485.32 325.32 480 335.986 480zm0 192c10.666 0 16.014 5.348 16.014 16.014v31.972C576 730.68 570.652 736 559.986 736h-224C325.319 736 320 730.652 320 719.986v-31.972C320 677.32 325.32 672 335.986 672zM190.009 478.009A46.28 46.28 0 01224 464.014c13.34 0 24.661 4.665 33.991 13.995 9.33 9.33 13.995 20.65 13.995 33.991 0 13.34-4.665 24.661-13.995 33.991A46.28 46.28 0 01224 560.014c-13.34 0-24.661-4.693-33.991-14.023A46.28 46.28 0 01175.986 512c0-13.34 4.693-24.661 14.023-33.991zm0 192A46.28 46.28 0 01224 656.014c13.34 0 24.661 4.665 33.991 13.995 9.33 9.33 13.995 20.65 13.995 33.991 0 13.34-4.665 24.661-13.995 33.991A46.28 46.28 0 01224 752.014c-13.34 0-24.661-4.693-33.991-14.023A46.28 46.28 0 01175.986 704c0-13.34 4.693-24.661 14.023-33.991zM672 128c26.68 0 49.323 9.33 67.982 27.99C758.67 174.676 768 197.347 768 224v704c0 26.68-9.33 49.323-27.99 67.982C721.324 1014.67 698.68 1024 672 1024H96c-26.68 0-49.323-9.33-67.982-27.99C9.3 977.324 0 954.68 0 928V224c0-26.652 9.33-49.323 27.99-67.982C46.676 137.33 69.32 128 96 128h178.005a65.764 65.764 0 01-1.99-15.986c0-30.691 10.979-57.002 32.995-79.018C326.997 11.008 353.337 0 384 0s57.003 11.008 78.99 32.996c22.016 22.016 32.996 48.355 32.996 79.018A65.45 65.45 0 01493.995 128zM417.991 77.995A46.28 46.28 0 00384 64c-13.34 0-24.661 4.665-33.991 13.995a46.28 46.28 0 00-14.023 34.02c0 13.311 4.693 24.66 14.023 33.99C359.339 155.335 370.659 160 384 160c13.34 0 24.661-4.665 33.991-13.995 9.33-9.33 13.995-20.679 13.995-33.99 0-13.37-4.665-24.69-13.995-34.02zM704 928V224c0-9.33-2.987-17.01-8.988-23.012C689.01 195.015 681.358 192 672 192h-96v39.993c0 16.014-7.993 24.007-24.007 24.007H216.007C199.993 256 192 248.007 192 231.993V192H96c-9.33 0-17.01 2.987-23.012 8.988C67.015 206.99 64 214.642 64 224v704c0 9.33 2.987 17.01 8.988 23.012C78.99 956.985 86.642 960 96 960h576c9.33 0 17.01-3.015 23.012-8.988C700.985 945.01 704 937.358 704 928z"
      />
    </svg>
  )
}

const Contract: React.FC<IIconProps> = ({ width = 48, height = 48 }) => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="42637"
      width={width}
      height={height}
    >
      <path
        d="M760 896h-480a120 120 0 0 1-120-120v-224a120 120 0 0 1 120-120h480a120 120 0 0 1 120 120v224a120 120 0 0 1-120 120z m-480-416a72.16 72.16 0 0 0-72 72v224a72.16 72.16 0 0 0 72 72h480a72.16 72.16 0 0 0 72-72v-224a72.16 72.16 0 0 0-72-72z"
        p-id="42638"
        fill="#fff"
      />
      <path
        d="M728 480a24 24 0 0 1-24-24v-112a184 184 0 0 0-368 0v112a24 24 0 0 1-48 0v-112a232 232 0 0 1 464 0v112a24 24 0 0 1-24 24zM520 704a88 88 0 1 1 88-88 88.16 88.16 0 0 1-88 88z m0-128a40 40 0 1 0 40 40 40 40 0 0 0-40-40z"
        p-id="42639"
        fill="#fff"
      />
      <path
        d="M520 800a24 24 0 0 1-24-24v-96a24 24 0 0 1 48 0v96a24 24 0 0 1-24 24z"
        p-id="42640"
        fill="#fff"
      />
    </svg>
  )
}

const EditDots: React.FC<IIconProps> = ({ color = '#999c9e', width = 24, height = 24 }) => {
  return (
    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
      <path
        d="M608 208.512c0 44.48-35.84 80.512-80 80.512s-80-36.032-80-80.512c0-44.48 35.84-80.512 80-80.512s80 36.064 80 80.512zM608 496c0 44.48-35.84 80.544-80 80.544S448 540.48 448 496s35.84-80.544 80-80.544S608 451.52 608 496zm0 287.52A80.224 80.224 0 01528.032 864a80.224 80.224 0 01-79.968-80.48 80.224 80.224 0 0180-80.48A80.224 80.224 0 01608 783.52z"
        fill={color}
      />
    </svg>
  )
}

const CloudStatus: React.FC<IIconProps> = ({ color = '#16e2a8', width = 24, height = 24 }) => {
  return (
    <svg
      role="img"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M12.008 9.597a5.623 5.623 0 1 1 0 11.245 5.623 5.623 0 0 1 0-11.245zM.154 8.717l3.02 3.574a.639.639 0 0 0 .913.068c4.885-4.379 10.97-4.379 15.84 0a.642.642 0 0 0 .916-.068l3.006-3.574a.646.646 0 0 0-.075-.906c-7.1-6.204-16.462-6.204-23.555 0a.65.65 0 0 0-.065.906z"
      />
    </svg>
  )
}

const AppsIconFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 3.75L9.04999 3.75C9.4642 3.75 9.79999 4.08579 9.79999 4.5V9.04999C9.79999 9.4642 9.4642 9.79999 9.04999 9.79999H4.5C4.08579 9.79999 3.75 9.4642 3.75 9.04999L3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75ZM2.5 4.5C2.5 3.39543 3.39543 2.5 4.5 2.5L9.04999 2.5C10.1546 2.5 11.05 3.39543 11.05 4.5V9.04999C11.05 10.1546 10.1546 11.05 9.04999 11.05H4.5C3.39543 11.05 2.5 10.1546 2.5 9.04999L2.5 4.5ZM14.95 3.75L19.5 3.75C19.9142 3.75 20.25 4.08579 20.25 4.5V9.04999C20.25 9.4642 19.9142 9.79999 19.5 9.79999L14.95 9.79999C14.5358 9.79999 14.2 9.4642 14.2 9.04999V4.5C14.2 4.08579 14.5358 3.75 14.95 3.75ZM12.95 4.5C12.95 3.39543 13.8454 2.5 14.95 2.5L19.5 2.5C20.6046 2.5 21.5 3.39543 21.5 4.5V9.04999C21.5 10.1546 20.6046 11.05 19.5 11.05H14.95C13.8454 11.05 12.95 10.1546 12.95 9.04999V4.5ZM9.04999 14.2H4.5C4.08579 14.2 3.75 14.5357 3.75 14.95L3.75 19.4999C3.75 19.9142 4.08579 20.2499 4.5 20.2499H9.04999C9.4642 20.2499 9.79999 19.9142 9.79999 19.4999L9.79999 14.95C9.79999 14.5357 9.4642 14.2 9.04999 14.2ZM4.5 12.95C3.39543 12.95 2.5 13.8454 2.5 14.95L2.5 19.4999C2.5 20.6045 3.39543 21.4999 4.5 21.4999H9.04999C10.1546 21.4999 11.05 20.6045 11.05 19.4999V14.95C11.05 13.8454 10.1546 12.95 9.04999 12.95H4.5ZM14.95 14.2H19.5C19.9142 14.2 20.25 14.5357 20.25 14.95V19.4999C20.25 19.9142 19.9142 20.2499 19.5 20.2499H14.95C14.5358 20.2499 14.2 19.9142 14.2 19.4999V14.95C14.2 14.5357 14.5358 14.2 14.95 14.2ZM12.95 14.95C12.95 13.8454 13.8454 12.95 14.95 12.95H19.5C20.6046 12.95 21.5 13.8454 21.5 14.95V19.4999C21.5 20.6045 20.6046 21.4999 19.5 21.4999H14.95C13.8454 21.4999 12.95 20.6045 12.95 19.4999V14.95Z"
      fill="white"
    />
    <rect x="3" y="14" width="7" height="7" rx="1" fill="white" />
    <rect x="3" y="3" width="7" height="7" rx="1" fill="white" />
    <rect x="14" y="14" width="7" height="7" rx="1" fill="white" />
    <rect x="14" y="3" width="7" height="7" rx="1" fill="white" />
  </svg>
)

const KnowledgeCenterFilled = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 2V0.5C12.5 0.223858 12.2761 0 12 0C11.7239 0 11.5 0.223858 11.5 0.5V2C11.5 2.27614 11.7239 2.5 12 2.5C12.2761 2.5 12.5 2.27614 12.5 2ZM19.2403 2.96337L18.2761 4.11244C18.0986 4.32398 17.7832 4.35157 17.5717 4.17407C17.3601 3.99657 17.3326 3.68119 17.5101 3.46965L18.4742 2.32059C18.6517 2.10905 18.9671 2.08146 19.1787 2.25896C19.3902 2.43646 19.4178 2.75184 19.2403 2.96337ZM20 12C20 15.3034 17.9978 18.1392 15.1407 19.3599C15.2101 19.4736 15.25 19.6071 15.25 19.75C15.25 20.1642 14.9142 20.5 14.5 20.5H9.5C9.08579 20.5 8.75 20.1642 8.75 19.75C8.75 19.6071 8.78995 19.4736 8.85928 19.3599C6.00221 18.1392 4 15.3034 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12ZM13.1152 6.34994C15.0626 6.90571 16.5961 8.44002 17.1508 10.3877C17.2075 10.5869 17.092 10.7944 16.8929 10.8511C16.6937 10.9078 16.4862 10.7923 16.4295 10.5932C15.9458 8.89496 14.6073 7.55572 12.9094 7.07115C12.7102 7.01431 12.5949 6.80679 12.6517 6.60763C12.7085 6.40848 12.9161 6.29311 13.1152 6.34994ZM9.5 22C9.22386 22 9 21.7761 9 21.5C9 21.2239 9.22386 21 9.5 21H14.5C14.7761 21 15 21.2239 15 21.5C15 21.7761 14.7761 22 14.5 22H9.5ZM10 23.5C9.72386 23.5 9.5 23.2761 9.5 23C9.5 22.7239 9.72386 22.5 10 22.5H14C14.2761 22.5 14.5 22.7239 14.5 23C14.5 23.2761 14.2761 23.5 14 23.5H10ZM5.54142 2.31902L6.4854 3.48474C6.65918 3.69935 6.62609 4.01419 6.41149 4.18798C6.19689 4.36176 5.88204 4.32867 5.70826 4.11406L4.76428 2.94834C4.59049 2.73374 4.62359 2.41889 4.83819 2.24511C5.05279 2.07133 5.36764 2.10442 5.54142 2.31902Z"
      fill="white"
    />
    <circle cx="12" cy="12" r="8" fill="white" />
  </svg>
)

const PersonPlume = (props?: IIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.3115 11.377C22.3115 16.2021 18.3213 20.1924 13.4961 20.1924C12.2041 20.1924 10.9736 19.9023 9.86621 19.3926C10.6572 18.4434 11.1406 17.2393 11.1406 15.9297C11.1406 15.499 11.0879 15.0684 10.9824 14.6641C11.7295 14.4531 12.5732 14.3213 13.4873 14.3213C16.2734 14.3213 18.374 15.4814 19.1562 16.5625C20.4131 15.2002 21.1689 13.3809 21.1689 11.377C21.1689 7.12305 17.7412 3.69531 13.4873 3.69531C9.50586 3.69531 6.2627 6.70117 5.88477 10.5684C5.52441 10.5332 5.05859 10.5684 4.71582 10.6299C5.09375 6.13867 8.9082 2.56152 13.4873 2.56152C18.3125 2.56152 22.3115 6.54297 22.3115 11.377ZM16.4844 9.50488C16.4844 11.3857 15.1748 12.8271 13.4873 12.8184C11.8086 12.8008 10.499 11.377 10.4902 9.50488C10.4814 7.73828 11.8174 6.26172 13.4873 6.26172C15.1572 6.26172 16.4844 7.73828 16.4844 9.50488ZM10.1123 15.9473C10.1123 18.3379 8.11719 20.3154 5.74414 20.3154C3.35352 20.3154 1.37598 18.3467 1.37598 15.9473C1.37598 13.5479 3.35352 11.5703 5.74414 11.5703C8.14355 11.5703 10.1123 13.5479 10.1123 15.9473ZM7.5762 16.706C7.57621 16.6482 7.56114 16.5913 7.53246 16.541L6.74514 15.1813C6.74301 15.1775 6.74189 15.1732 6.7419 15.1689C6.74191 15.1645 6.74305 15.1602 6.7452 15.1565C6.74735 15.1527 6.75045 15.1495 6.75419 15.1473C6.75793 15.1451 6.76218 15.1438 6.76654 15.1437H6.98524C7.00271 15.1437 7.01988 15.1483 7.035 15.1571C7.05011 15.1659 7.06264 15.1785 7.07129 15.1937L7.77018 16.4036C7.82297 16.4958 7.85075 16.6002 7.85075 16.7065C7.85075 16.8127 7.82297 16.9171 7.77018 17.0093L6.93199 18.4613C6.83744 18.6252 6.70141 18.7612 6.53757 18.8558C6.37373 18.9504 6.18788 19.0001 5.99871 19H4.10267C4.08258 19 4.06274 18.9956 4.04452 18.9872C4.02631 18.9787 4.01016 18.9664 3.99721 18.951C3.98425 18.9357 3.97481 18.9177 3.96954 18.8983C3.96427 18.8789 3.9633 18.8586 3.96669 18.8388C3.97327 18.806 3.99115 18.7766 4.01722 18.7557C4.04329 18.7347 4.07589 18.7236 4.10933 18.7242H5.99633C6.13704 18.7243 6.27527 18.6873 6.39713 18.6169C6.51898 18.5465 6.62015 18.4453 6.69047 18.3235L7.53151 16.8724C7.56076 16.8218 7.57617 16.7645 7.5762 16.706ZM6.03722 17.9621C6.08746 17.9331 6.12926 17.8915 6.15845 17.8414L6.93722 16.4816C6.93945 16.4779 6.94262 16.4748 6.94641 16.4726C6.95021 16.4705 6.95449 16.4693 6.95885 16.4693C6.96321 16.4693 6.96749 16.4705 6.97129 16.4726C6.97508 16.4748 6.97825 16.4779 6.98048 16.4816L7.08983 16.6718C7.09846 16.6869 7.103 16.7041 7.103 16.7215C7.103 16.7389 7.09846 16.756 7.08983 16.7712L6.39142 17.9802C6.33822 18.0719 6.26195 18.148 6.17021 18.201C6.07846 18.2541 5.97442 18.2822 5.86844 18.2826H4.193C4.00387 18.2825 3.81808 18.2327 3.65433 18.138C3.49057 18.0434 3.35464 17.9073 3.2602 17.7434L2.31265 16.1013C2.30291 16.0846 2.2968 16.066 2.29473 16.0467C2.29266 16.0275 2.29468 16.0081 2.30065 15.9897C2.30662 15.9713 2.31641 15.9543 2.32937 15.94C2.34234 15.9256 2.35819 15.9141 2.37589 15.9063C2.40842 15.8929 2.44478 15.892 2.47795 15.9037C2.51113 15.9155 2.53879 15.9391 2.5556 15.97L3.49887 17.6055C3.5693 17.7274 3.67049 17.8285 3.79231 17.8989C3.91412 17.9694 4.0523 18.0066 4.193 18.0068H5.87129C5.92953 18.0065 5.9867 17.9911 6.03722 17.9621ZM4.18017 17.2571C4.23033 17.2861 4.2872 17.3015 4.34514 17.3017L5.9098 17.3013C5.91414 17.3013 5.9184 17.3024 5.92216 17.3046C5.92591 17.3068 5.92903 17.3099 5.9312 17.3136C5.93337 17.3174 5.93451 17.3217 5.93451 17.326C5.93451 17.3303 5.93336 17.3346 5.9312 17.3384L5.82185 17.5285C5.81286 17.5432 5.8002 17.5554 5.78511 17.5637C5.77002 17.572 5.75303 17.5763 5.73579 17.5761H4.33896C4.23288 17.5756 4.12876 17.5474 4.03699 17.4942C3.94523 17.441 3.86902 17.3646 3.81598 17.2727L2.97684 15.8193C2.88233 15.6555 2.83257 15.4698 2.83257 15.2807C2.83257 15.0916 2.88233 14.9058 2.97684 14.742L3.92771 13.0998C3.9378 13.0825 3.95156 13.0675 3.96801 13.056C3.98447 13.0445 4.00323 13.0367 4.023 13.0332C4.04277 13.0297 4.06308 13.0305 4.0825 13.0356C4.10192 13.0407 4.12 13.05 4.13547 13.0628C4.16073 13.0849 4.17735 13.1153 4.18239 13.1485C4.18744 13.1818 4.18059 13.2157 4.16305 13.2444L3.21788 14.8799C3.14758 15.0017 3.11057 15.14 3.11057 15.2807C3.11057 15.4214 3.14758 15.5596 3.21788 15.6815L4.05703 17.1349C4.08633 17.1859 4.12887 17.2281 4.18017 17.2571ZM3.8621 15.2964C3.86189 15.3542 3.87698 15.4112 3.90584 15.4613L4.68936 16.8235C4.69153 16.8272 4.69267 16.8315 4.69267 16.8358C4.69267 16.8402 4.69153 16.8444 4.68936 16.8482C4.68719 16.8519 4.68407 16.8551 4.68032 16.8572C4.67656 16.8594 4.6723 16.8605 4.66796 16.8605H4.44926C4.43179 16.8606 4.41462 16.856 4.3995 16.8472C4.38438 16.8384 4.37186 16.8258 4.36321 16.8106L3.66527 15.6011C3.61229 15.509 3.58441 15.4045 3.58441 15.2983C3.58441 15.192 3.61229 15.0875 3.66527 14.9954L4.50441 13.5387C4.59903 13.3749 4.73508 13.2389 4.8989 13.1443C5.06272 13.0498 5.24854 13 5.43769 13H7.33516C7.35522 13.0001 7.37502 13.0045 7.3932 13.013C7.41137 13.0215 7.42749 13.0338 7.44042 13.0491C7.45336 13.0645 7.4628 13.0824 7.4681 13.1018C7.47341 13.1211 7.47444 13.1414 7.47113 13.1612C7.46466 13.194 7.44682 13.2236 7.42074 13.2446C7.39466 13.2657 7.362 13.2769 7.3285 13.2762H5.43959C5.29891 13.2763 5.16071 13.3133 5.03887 13.3837C4.91703 13.454 4.81584 13.5552 4.74546 13.677L3.90631 15.1304C3.87732 15.1809 3.86207 15.2381 3.8621 15.2964ZM5.40156 14.0403C5.35149 14.0695 5.30974 14.1111 5.28032 14.161L4.49253 15.5227C4.49035 15.5264 4.48723 15.5295 4.48348 15.5317C4.47972 15.5339 4.47547 15.535 4.47113 15.535C4.4668 15.535 4.46254 15.5339 4.45878 15.5317C4.45503 15.5295 4.45191 15.5264 4.44974 15.5227L4.34039 15.3325C4.33152 15.3174 4.32685 15.3003 4.32685 15.2828C4.32685 15.2653 4.33152 15.2482 4.34039 15.2331L5.04118 14.0222C5.09456 13.9307 5.17086 13.8547 5.26257 13.8016C5.35428 13.7486 5.45823 13.7204 5.56416 13.7198H7.24245C7.43165 13.7198 7.61752 13.7696 7.78136 13.8643C7.94519 13.9589 8.08121 14.095 8.17573 14.259L9.12327 15.9016C9.13294 15.9183 9.13899 15.9369 9.14102 15.9561C9.14304 15.9753 9.14101 15.9947 9.13505 16.0131C9.12909 16.0315 9.11933 16.0484 9.10641 16.0628C9.09348 16.0772 9.07769 16.0886 9.06004 16.0965C9.02745 16.1099 8.99105 16.1108 8.95787 16.0989C8.92468 16.0871 8.89706 16.0633 8.88032 16.0323L7.93658 14.3968C7.86631 14.2749 7.76514 14.1737 7.64328 14.1033C7.52142 14.033 7.38316 13.996 7.24245 13.996H5.56749C5.50926 13.996 5.45205 14.0113 5.40156 14.0403ZM7.25836 14.746C7.20833 14.7168 7.15155 14.7011 7.09364 14.7006L5.52089 14.703C5.51656 14.703 5.51229 14.7019 5.50854 14.6997C5.50478 14.6975 5.50166 14.6944 5.4995 14.6906C5.49733 14.6869 5.49619 14.6826 5.49619 14.6783C5.49619 14.6739 5.49733 14.6697 5.4995 14.6659L5.60885 14.4758C5.6175 14.4606 5.63003 14.448 5.64514 14.4392C5.66026 14.4304 5.67743 14.4258 5.6949 14.4258H7.09459C7.20061 14.4265 7.30462 14.4549 7.39634 14.5081C7.48805 14.5613 7.56431 14.6375 7.61757 14.7292L8.45671 16.1826C8.55122 16.3464 8.60096 16.5323 8.60096 16.7215C8.60096 16.9106 8.55122 17.0965 8.45671 17.2604L7.50822 18.9021C7.49818 18.9195 7.48445 18.9345 7.468 18.9461C7.45155 18.9576 7.43276 18.9654 7.41297 18.969C7.39317 18.9725 7.37284 18.9717 7.35341 18.9665C7.33397 18.9614 7.3159 18.952 7.30045 18.9391C7.27519 18.917 7.25858 18.8866 7.25353 18.8534C7.24849 18.8201 7.25534 18.7862 7.27288 18.7575L8.21804 17.122C8.28835 17.0002 8.32536 16.8619 8.32536 16.7212C8.32536 16.5805 8.28835 16.4423 8.21804 16.3204L7.3789 14.867C7.34994 14.8169 7.30839 14.7751 7.25836 14.746Z"
      fill="black"
    />
  </svg>
)

export {
  Close,
  CloseVideo,
  House,
  Network,
  Cart,
  Account,
  User,
  Support,
  PodWhite,
  SignOut,
  Play,
  PlayDashboard,
  PlayCircled,
  AccountManager,
  PartialLogo,
  CartBlack,
  Phone,
  Dot,
  DotBig,
  Pod,
  Mobile,
  Clock,
  Key,
  Attention,
  Attention2,
  Plume,
  LeftArrow,
  LeftDoubleArrow,
  RightArrow,
  RightDoubleArrow,
  DownArrow,
  UpArrow,
  CircledLogo,
  LogoBronze,
  LogoSilver,
  LogoGold,
  Checked,
  Plus,
  Minus,
  Download,
  Settings,
  CheckCircled,
  PlusRounded,
  PlusRoundedDisabled,
  InfoButton,
  QuestionMarkRounded,
  KnowledgeCenter,
  CopyToClipboardIcon,
  Contract,
  EditDots,
  CloudStatus,
  AppsIconFilled,
  KnowledgeCenterFilled,
  PersonPlume,
}
